import VacanciesPage from "./VacanciesPage";
export default VacanciesPage;